/* eslint-disable react-hooks/exhaustive-deps */

import { Checkbox, Col, Input, Row } from "antd";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { useSelector } from "react-redux";
import { SearchIcon } from "src/assets/icons";
import CalendarIcon from "src/assets/icons/CalendarIcon";
import NafutelDatePickerComponent from "src/components/date-picker";
import { NafutelQueryStringContextProvider } from "src/context/QueryContext";
import { getCheckboxOptions } from "./helpers";
import "./styles.scss";
import { ReservationCheckbox } from "./types";
import "react-datepicker/dist/react-datepicker.css";
import useAuth from "src/hooks/useAuth";
import { useTranslation } from "react-i18next";
import { registerDatepickerLocale } from "src/utils/datetime";
registerDatepickerLocale();

interface IProps {
  styleLeftBg?: React.CSSProperties;
  styleRightBg?: React.CSSProperties;
  parentCss?: React.CSSProperties;
  styleTextCheckbox?: React.CSSProperties;
  listCheckbox?: ReservationCheckbox[];
  callback?: (filter: any) => void;
}

function ReservationSearch({
  styleLeftBg,
  parentCss,
  styleTextCheckbox,
  styleRightBg,
  listCheckbox = [],
  callback,
}: IProps) {
  const [checkBoxes, setCheckboxes] = useState(listCheckbox);
  const [textSearch, setTextSearch] = useState("");
  const [dateSearch, setDateSearch] = useState<string | undefined>();
  const { t } = useTranslation();

  const reservationListReducer = useSelector(
    (state: any) => state.reservationList
  );
  const { auth }: any = useAuth();

  const isChecked = (e: any) => {
    const currentCb = checkBoxes.find((cb) => cb.value === e.value);
    return currentCb && currentCb.checked;
  };

  useEffect(() => {
    const filter = getFilterOptions();
    callback && callback(filter);
  }, [reservationListReducer]);

  const getFilterOptions = () => {
    const options = getCheckboxOptions(checkBoxes);
    let filter: any = {
      param_datas: {
        pagination: {
          size: 100,
        },
        user_id: auth?.user?.user_id,
        order: reservationListReducer.order,
        ...options,
      },
    };
    if (textSearch) {
      filter = {
        ...filter,
        param_datas: {
          ...filter.param_datas,
          text: textSearch,
        },
      };
    }
    if (dateSearch) {
      filter = {
        ...filter,
        param_datas: {
          ...filter.param_datas,
          date: dateSearch,
        },
      };
    }
    return filter;
  };

  const handleCheckbox = (e: CheckboxChangeEvent, cb: ReservationCheckbox) => {
    setCheckboxes(
      checkBoxes.map((cbox) => {
        if (cbox.value === cb.value) {
          cbox.checked = e.target.checked;
        }
        return cbox;
      })
    );
    const filter = getFilterOptions();
    callback && callback(filter);
  };

  const handleClickSearch = () => {
    const filter = getFilterOptions();
    callback && callback(filter);
  };

  return (
    <div
      className={`ReservationSearchStyle ${!isMobile ? "grid-web-mode" : ""}`}
      style={{ ...parentCss, bottom: "0px" }}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div
        className={`${
          isMobile ? "filter-condition-mobile" : "filter-condition"
        } ${isMobile ? `filter-condition-mobile-arrow` : ""} ${
          !isMobile && "filter-condition-detail"
        }`}
        style={{ ...styleLeftBg }}
      >
        <Row>
          <Col xs={isMobile ? 24 : 15}>
            <div className="reservation-wrap-input">
              <Input
                placeholder={t("reservationList.search.input.placeholder")!}
                onChange={(e) => {
                  setTextSearch(e.target.value);
                }}
                className="reservation-input"
              />
              <div className="reservation-input-icon">
                <SearchIcon />
              </div>
            </div>
          </Col>
          <Col xs={isMobile ? 24 : 9}>
            <NafutelDatePickerComponent
              allowSelectPastDate
              IconDate={() => <CalendarIcon width={20} height={20} />}
              placeholder={t("reservationList.search.date.placeholder")!}
              onChange={(e) => {
                if (e) {
                  setDateSearch(moment(e).format("YYYY-M-D"));
                } else {
                  setDateSearch(undefined);
                }
              }}
              remove
            />
          </Col>
        </Row>
        <Row>
          <Col xs={isMobile ? 24 : 15}>
            <div className="reservation-check-box-search">
              <ul className="ul-wrap-check-box-search">
                {checkBoxes.map((checkbox: any, index: number) => {
                  return (
                    <li key={index}>
                      <Checkbox
                        className={`nafutel-checkbox-input checkbox-input-blue`}
                        checked={isChecked(checkbox)}
                        key={index}
                        onChange={(e) => handleCheckbox(e, checkbox)}
                      >
                        <span style={{ ...styleTextCheckbox, fontSize: 15 }}>
                          {checkbox.label}
                        </span>
                      </Checkbox>
                    </li>
                  );
                })}
              </ul>
            </div>
          </Col>
        </Row>
      </div>
      <div
        className={`search-btn ${isMobile ? "search-btn-mobile" : ""}`}
        onClick={handleClickSearch}
        style={{ ...styleRightBg }}
      >
        {t("reservationList.search.button.label")}
      </div>
    </div>
  );
}

function ReservationSearchComponent(props: IProps) {
  return (
    <NafutelQueryStringContextProvider>
      <ReservationSearch {...props} />
    </NafutelQueryStringContextProvider>
  );
}

export default ReservationSearchComponent;
